namespace GeniuzPOS.Product {
    export class CsDocTypeColumns {
        static columnsKey = 'Product.CsDocType';
    }
}
